import React, { useState, useEffect, useCallback, useMemo } from "react";
import { withRouter } from "react-router-dom";

import Loading from "../Common/Loading/Loading";
import Header from "../Common/Header";
import Body from "../Common/Body";
import List from "./AssistantList";
import { Pagination, InputGroup, FormControl, Button } from "react-bootstrap";
import { STIPOP_API_HOST, STIPOP_API_KEY, DMM_API_HOST, DMM_API_KEY } from "../../_Components/Common/common";

const assistant = (props) => {

    const [isLoading,       setIsLoading]       = useState(true);
    const [models,          setModels]          = useState([]);
    const [assistantList,   setAssistantList]   = useState([]);
    const [fieldList,       setFieldList]       = useState([]);
    const [pageMap,         setPageMap]         = useState({});
    const [pageNumber,      setPageNumber]      = useState(1);
    const [search,          setSearch]          = useState('');

    const getAssistantList = async (pageNumber, search) => {

        const response = await fetch(`${STIPOP_API_HOST}/v4.0.1/assistant?pageNumber=${pageNumber}&limit=100&search=${search}`, {
        // const response = await fetch(`http://localhost:3000/v4.0.1/assistant?pageNumber=${pageNumber}&limit=100&search=${search}`, {
            headers : {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                token: sessionStorage.getItem("token"),
                apikey: STIPOP_API_KEY
                // apikey: 'a3e68b6c54d8132f6879d5bc2c49708d'
            },
            method:'get'
        });

        const responseJson = await response.json();

        if (fieldList.length === 0) {
            
            let fields = [];
            
            for (let key in responseJson.body.assistantList[0]) {
                fields.push(key);
            }

            fields.splice(fields.indexOf('nudity'), 1);
            fields.splice(fields.indexOf('assistantImg') + 1, 0, 'nudity')

            setFieldList(fields);

        }

        setAssistantList(responseJson.body.assistantList);
        setPageMap(responseJson.body.pageMap);

    }

    const getModelList = async () => {

        const response = await fetch(`${STIPOP_API_HOST}/v4.0.1/assistant/models`, {
            headers : {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                token: sessionStorage.getItem("token"),
                apikey: STIPOP_API_KEY
            },
            method:'get'
        });

        const responseJson = await response.json();

        setModels(responseJson.body);

    };

    const assistantToDMM = async (data) => {
        console.log(data);
        await fetch(`${DMM_API_HOST}/v4.0.1/assistant/toDMM`, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                apikey: DMM_API_KEY
            },
            method: 'post',
            body: JSON.stringify(data)
        })

        alert('success')
    }

    const assistantDelete = async (assistantId) => {
        fetch(`${STIPOP_API_HOST}/v4.0.1/assistant/${assistantId}`, {
            headers : {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                token: sessionStorage.getItem("token"),
                apikey: STIPOP_API_KEY
            },
            method:'delete'
        });

        alert('삭제');

        window.location.reload();
    };

    const assistantUpdate = async (data) => {
        console.log(data);

        data && props.history.push('/AssistantCreate', {data, models});
    };

    const statusUpdate = async (assistantId, status) => {

        const params = {
            status
        };
        
        const response = await fetch(`${STIPOP_API_HOST}/v4.0.1/assistant/${assistantId}/status`, {
            headers : {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                token: sessionStorage.getItem("token"),
                apikey: STIPOP_API_KEY
            },
            method:'put',
            body: JSON.stringify(params)
        });

        alert('success');

    };

    const toRoyalChat = async (data) => {
      // console.log(data);
      // const response = await fetch(`http://localhost:3000/v1/assistant/royalchat`, {
      const response = await fetch(`https://api.royalchat.ai/v1/assistant/royalchat`, {
          headers : {
              Accept: "application/json",
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              token: sessionStorage.getItem("token"),
              // apikey: '183a04c0815a6228c40e7dfa23a77ab3'
              apikey: 'b7d85e59d3a6bda31bc287b85ac2a83f'
          },
          method:'post',
          body: JSON.stringify(data)
      });

      alert('success');

    };

    const handleSubmit = event => {
        event.preventDefault()
        setPageNumber(1)
        getAssistantList(1, search)
      }
    
    const keyEvent = event => {
        if (event.key === 'Enter') {
            handleSubmit(event)
        }
    }    

    const renderPaging = (pageNumber, pageMap) => {
        let list = []
        let j = 0
        let i = 0
    
        let test = pageNumber !== 1 ? pageNumber - 1 : 1
        let last =
          pageNumber !== pageMap.pageCount ? pageNumber * 1 + 1 : pageMap.pageCount
    
        list.push(
          <Pagination.Item
            key="first"
            onClick={() => {
              setPageNumber(test)
            }}
          >
            &laquo;
          </Pagination.Item>
        )
    
        for (i = pageMap.startPage * 1; i <= pageMap.endPage; i++) {
          let num = pageMap.startPage * 1 + j
    
          if (num === pageMap.pageNumber * 1) {
            list.push(
              <Pagination.Item key={i} className="active">
                {num}
              </Pagination.Item>
            )
          } else {
            list.push(
              <Pagination.Item
                key={i}
                onClick={() => {
                  setPageNumber(num)
                }}
              >
                {num}
              </Pagination.Item>
            )
          }
          j++
        }
    
        list.push(
          <Pagination.Item
            key="last"
            onClick={() => {
              setPageNumber(last)
            }}
          >
            &raquo;
          </Pagination.Item>
        )
        return <Pagination>{list}</Pagination>
      }

    const dataComponent = () => {
        return (
            <List 
                fieldList={fieldList} 
                dataList={assistantList} 
                isAssistant={true} 
                assistantDelete={(assistantId) => assistantDelete(assistantId)} 
                assistantUpdate={(data) => assistantUpdate(data)} 
                statusUpdate={(assistantId, status) => statusUpdate(assistantId, status)}
                toRoyalChat={(data) => toRoyalChat(data)}
                assistantToDMM={(data) => assistantToDMM(data)}
            />
        )
    };

    useEffect(() => { 
        
        const fetchData = async () => {
            await getAssistantList(pageNumber, search);
            await getModelList();
            setIsLoading(false);
        }

        fetchData();

        return async () => {

        }

    }, [pageNumber]);

    if (isLoading) {
        return (
            <Loading />
        )
    } else {
        return (
            <>
            <Header title={"Assistant"} button={true} onClick={() => props.history.push('/AssistantCreate', {models})} />
            <InputGroup onSubmit={handleSubmit}>
                <FormControl
                    type="text"
                    value={search}
                    placeholder="Search"
                    onChange={event => setSearch(event.target.value)}
                    onKeyPress={keyEvent}
                />
                <Button variant="primary" onClick={handleSubmit} style={{ height: '38px'}}>
                <i className="fa fa-search" />
                </Button>
            </InputGroup>
            <Body headerWidth={"20%"} DataComponet={dataComponent} />
            {renderPaging(pageNumber, pageMap)}
            </>
        )
    }
}

export default withRouter(assistant);